
import { defineComponent } from 'vue'
import { ColorEnum } from '../../enums'
import { CopyToClipboard, DefaultImage, EpbText } from './'

export default defineComponent({
  name: 'HorizontalResultCard',
  components: { EpbText, CopyToClipboard, DefaultImage },
  props: {
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      baseClass: 'horizontal-result-card',
      ColorEnum,
    }
  },
})
